/* eslint-disable react/prop-types */
import { useMemo, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const createItem = () => ({
  recordingDate: "",
  voucherNumber: "",
  voucherDate: "",
  description: "",
  correspondingAccount: "",
  actualPrice: "",
  increaseQuantity: "",
  increaseParValue: "",
  increaseActualPurchasePrice: "",
  decreaseQuantity: "",
  decreaseParValue: "",
  decreaseActualPurchasePrice: "",
  balanceQuantity: "",
  balanceParValue: "",
  balanceActualPurchasePrice: "",
});

const defaultItems = [createItem()];

function RegisterOwnSharesPurchasedInfo({ formData }) {
  const { values = {}, onChangeValue } = formData || {};
  const location = useLocation();
  const containView = location.pathname?.includes("/view");

  const [headerInfo, setHeaderInfo] = useState({
    unit: "",
    companyAddress: "",
    year: "",
    shareType: "",
    shareCode: "",
    measurementUnit: "",
    totalPages: "",
    openingDate: "",
    signingDay: "",
    signingMonth: "",
    signingYear: "",
    recorder: "",
    chiefAccountant: "",
    legalRepresentative: "",
  });

  const [localItems, setLocalItems] = useState(defaultItems);

  useEffect(() => {
    if (values.transactions && Array.isArray(values.transactions) && values.transactions.length > 0) {
      setLocalItems(values.transactions);
    }
    setHeaderInfo((prev) => ({ ...prev, ...values }));
  }, [values]);

  const handleHeaderChange = (field, val) => {
    setHeaderInfo((prev) => ({ ...prev, [field]: val }));
    if (onChangeValue) onChangeValue(field, val);
  };

  const handleChangeItem = (index, field, value) => {
    const newItems = [...localItems];
    newItems[index] = { ...newItems[index], [field]: value };
    setLocalItems(newItems);
  };

  const addRow = () => setLocalItems([...localItems, createItem()]);

  const removeRow = (index) => {
    if (localItems.length <= 1) return;
    setLocalItems(localItems.filter((_, i) => i !== index));
  };

  // Tính tổng
  const num = (val) => (val && val !== "" && !isNaN(val) ? parseFloat(val) : 0);

  const calculatedTotal = useMemo(() => {
    return {
      increaseQuantity: localItems.reduce((a, b) => a + num(b.increaseQuantity), 0),
      increaseParValue: localItems.reduce((a, b) => a + num(b.increaseParValue), 0),
      increaseActualPurchasePrice: localItems.reduce((a, b) => a + num(b.increaseActualPurchasePrice), 0),
      decreaseQuantity: localItems.reduce((a, b) => a + num(b.decreaseQuantity), 0),
      decreaseParValue: localItems.reduce((a, b) => a + num(b.decreaseParValue), 0),
      decreaseActualPurchasePrice: localItems.reduce((a, b) => a + num(b.decreaseActualPurchasePrice), 0),
    };
  }, [localItems]);

  useEffect(() => {
    if (onChangeValue) {
      onChangeValue("transactions", localItems);
    }
  }, [localItems]);

  const s = {
    container: {
      fontFamily: '"Times New Roman", Times, serif',
      color: "#000",
      padding: "20px",
      backgroundColor: "#fff",
      fontSize: "14px",
    },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "20px" },
    inputDotted: {
      border: "none",
      borderBottom: "1px dotted #000",
      outline: "none",
      fontSize: "14px",
      fontFamily: "inherit",
      backgroundColor: "transparent",
      display: "inline-block",
      color: "#000",
      fontWeight: "bold",
    },
    inputDottedSmall: {
      border: "none",
      borderBottom: "1px dotted #000",
      outline: "none",
      width: "40px",
      fontSize: "14px",
      fontFamily: "inherit",
      textAlign: "center",
      backgroundColor: "transparent",
      display: "inline-block",
      color: "#000",
      fontWeight: "bold"
    },
    titleBox: { textAlign: "center", margin: "20px 0" },
    titleMain: { fontSize: "18px", fontWeight: "bold", margin: 0 },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "14px", marginTop: "15px" },
    th: {
      border: "1px solid #000",
      padding: "8px 4px",
      textAlign: "center",
      fontWeight: "bold",
      verticalAlign: "middle",
    },
    td: { border: "1px solid #000", padding: 0, height: "35px", verticalAlign: "middle" },
    tdText: { border: "1px solid #000", padding: "0 8px", height: "35px", verticalAlign: "middle", textAlign: "center", fontWeight: "bold" },
    inputTableCenter: {
      width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center",
      fontSize: "14px", fontFamily: "inherit", background: "transparent", color: "#000"
    },
    inputTableRight: {
      width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right",
      fontSize: "14px", fontFamily: "inherit", background: "transparent", color: "#000", padding: "0 4px"
    },
    inputTableLeft: {
      width: "100%", height: "100%", border: "none", outline: "none", textAlign: "left",
      fontSize: "14px", fontFamily: "inherit", background: "transparent", color: "#000", padding: "0 4px"
    },
    totalText: { padding: "0 4px", textAlign: "right", fontWeight: "bold", display: "block" },
    removeBtn: { border: "none", background: "transparent", color: "red", fontWeight: "bold", cursor: "pointer", width: "100%", height: "100%" },
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  return (
    <SoftBox style={s.container}>
      <div style={s.headerTop}>
        <div style={{ width: "60%" }}>
          <div style={{ fontWeight: "bold", marginBottom: 5 }}>
            Đơn vị:{" "}
            <input
              disabled={containView}
              style={{ ...s.inputDotted, width: "350px" }}
              value={headerInfo.unit}
              onChange={(e) => handleHeaderChange("unit", e.target.value)}
            />
          </div>
          <div style={{ fontWeight: "bold" }}>
            Địa chỉ:{" "}
            <input
              disabled={containView}
              style={{ ...s.inputDotted, width: "350px" }}
              value={headerInfo.companyAddress}
              onChange={(e) => handleHeaderChange("companyAddress", e.target.value)}
            />
          </div>
        </div>
        <div style={{ textAlign: "center", width: "40%" }}>
          <div style={{ fontWeight: "bold" }}>Mẫu số S44-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "14px", marginTop: 4 }}>
            (Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)
          </div>
        </div>
      </div>

      <div style={s.titleBox}>
        <h2 style={s.titleMain}>SỔ CHI TIẾT CỔ PHIẾU MUA LẠI CỦA CHÍNH MÌNH</h2>
        <div style={{ marginTop: 5 }}>
          Năm:{" "}
          <input
            disabled={containView}
            style={{ ...s.inputDotted, width: "100px", textAlign: "center" }}
            value={headerInfo.year}
            onChange={(e) => handleHeaderChange("year", e.target.value)}
          />
        </div>
        <div style={{ marginTop: 5, display: "flex", justifyContent: "center", gap: "20px" }}>
          <div>
            Loại cổ phiếu:{" "}
            <input
              disabled={containView}
              style={{ ...s.inputDotted, width: "150px", textAlign: "center" }}
              value={headerInfo.shareType}
              onChange={(e) => handleHeaderChange("shareType", e.target.value)}
            />
          </div>
          <div>
            Mã số:{" "}
            <input
              disabled={containView}
              style={{ ...s.inputDotted, width: "80px", textAlign: "center" }}
              value={headerInfo.shareCode}
              onChange={(e) => handleHeaderChange("shareCode", e.target.value)}
            />
          </div>
        </div>
        <div style={{ textAlign: "right", marginTop: 5, fontStyle: "italic" }}>
          Đơn vị tính:{" "}
          <input
            disabled={containView}
            style={{ ...s.inputDotted, width: "100px", textAlign: "right" }}
            value={headerInfo.measurementUnit}
            onChange={(e) => handleHeaderChange("measurementUnit", e.target.value)}
          />
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th rowSpan={3} style={{ ...s.th, width: "6%" }}>Ngày<br />tháng<br />ghi sổ</th>
              <th colSpan={2} style={{ ...s.th, width: "10%" }}>Chứng từ</th>
              <th rowSpan={3} style={{ ...s.th, width: "15%" }}>Diễn giải</th>
              <th rowSpan={3} style={{ ...s.th, width: "5%" }}>Tài<br />khoản<br />đối ứng</th>
              <th rowSpan={3} style={{ ...s.th, width: "6%" }}>Giá<br />thực<br />tế<br />mua,<br />tái<br />phát<br />hành</th>
              <th colSpan={6} style={{ ...s.th, width: "36%" }}>Số phát sinh</th>
              <th colSpan={3} style={{ ...s.th, width: "18%" }}>Số dư</th>
              {!containView && <th rowSpan={4} style={{ ...s.th, width: "3%" }}>#</th>}
            </tr>
            <tr>
              <th rowSpan={2} style={s.th}>Số<br />hiệu</th>
              <th rowSpan={2} style={s.th}>Ngày<br />tháng</th>
              <th colSpan={3} style={s.th}>Tăng</th>
              <th colSpan={3} style={s.th}>Giảm</th>
              <th rowSpan={2} style={s.th}>Số<br />lượng</th>
              <th rowSpan={2} style={s.th}>Giá trị<br />theo<br />mệnh<br />giá</th>
              <th rowSpan={2} style={s.th}>Giá<br />mua<br />thực<br />tế</th>
            </tr>
            <tr>
              <th style={s.th}>Số<br />lượng</th>
              <th style={s.th}>Giá trị<br />theo<br />mệnh<br />giá</th>
              <th style={s.th}>Giá<br />mua<br />thực<br />tế</th>
              <th style={s.th}>Số<br />lượng</th>
              <th style={s.th}>Giá trị<br />theo<br />mệnh<br />giá</th>
              <th style={s.th}>Giá<br />mua<br />thực<br />tế</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>D</th>
              <th style={s.th}>E</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3</th>
              <th style={s.th}>4</th>
              <th style={s.th}>5</th>
              <th style={s.th}>6</th>
              <th style={s.th}>7</th>
              <th style={s.th}>8</th>
              <th style={s.th}>9</th>
              <th style={s.th}>10</th>
            </tr>
          </thead>
          <tbody>
            {localItems.map((row, i) => (
              <tr key={i}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={row.recordingDate} onChange={(e) => handleChangeItem(i, "recordingDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={row.voucherNumber} onChange={(e) => handleChangeItem(i, "voucherNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={row.voucherDate} onChange={(e) => handleChangeItem(i, "voucherDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableLeft} value={row.description} onChange={(e) => handleChangeItem(i, "description", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={row.correspondingAccount} onChange={(e) => handleChangeItem(i, "correspondingAccount", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.actualPrice} onChange={(e) => handleChangeItem(i, "actualPrice", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.increaseQuantity} onChange={(e) => handleChangeItem(i, "increaseQuantity", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.increaseParValue} onChange={(e) => handleChangeItem(i, "increaseParValue", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.increaseActualPurchasePrice} onChange={(e) => handleChangeItem(i, "increaseActualPurchasePrice", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.decreaseQuantity} onChange={(e) => handleChangeItem(i, "decreaseQuantity", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.decreaseParValue} onChange={(e) => handleChangeItem(i, "decreaseParValue", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.decreaseActualPurchasePrice} onChange={(e) => handleChangeItem(i, "decreaseActualPurchasePrice", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.balanceQuantity} onChange={(e) => handleChangeItem(i, "balanceQuantity", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.balanceParValue} onChange={(e) => handleChangeItem(i, "balanceParValue", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.balanceActualPurchasePrice} onChange={(e) => handleChangeItem(i, "balanceActualPurchasePrice", e.target.value)} /></td>
                {!containView && (
                  <td style={{ ...s.td, textAlign: "center" }}>
                    <button type="button" style={s.removeBtn} onClick={() => removeRow(i)}>X</button>
                  </td>
                )}
              </tr>
            ))}
            <tr style={{ backgroundColor: "#fafafa" }}>
              <td style={s.tdText} colSpan={4}>Cộng</td>
              <td style={s.tdText}>x</td>
              <td style={s.tdText}>x</td>
              <td style={s.tdText}>x</td>
              <td style={s.td}><span style={s.totalText}>{fmt(calculatedTotal.increaseParValue)}</span></td>
              <td style={s.td}><span style={s.totalText}>{fmt(calculatedTotal.increaseActualPurchasePrice)}</span></td>
              <td style={s.tdText}>x</td>
              <td style={s.td}><span style={s.totalText}>{fmt(calculatedTotal.decreaseParValue)}</span></td>
              <td style={s.td}><span style={s.totalText}>{fmt(calculatedTotal.decreaseActualPurchasePrice)}</span></td>
              <td style={s.tdText}>x</td>
              <td style={s.tdText}></td>
              <td style={s.tdText}></td>
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>
        {!containView && (
          <SoftBox mt={3} textAlign="center">
            <SoftButton variant="outlined" color="dark" onClick={addRow}>Thêm dòng</SoftButton>
          </SoftBox>
        )}
      </div>

      <div style={{ marginTop: "20px" }}>
        <div style={{ marginBottom: "5px" }}>
          - Sổ này có{" "}
          <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={headerInfo.totalPages} onChange={(e) => handleHeaderChange("totalPages", e.target.value)} />{" "}
          trang, đánh số từ trang 01 đến trang...
        </div>
        <div>
          - Ngày mở sổ:{" "}
          <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={headerInfo.openingDate} onChange={(e) => handleHeaderChange("openingDate", e.target.value)} />
        </div>
      </div>

      {/* FOOTER CHỮ KÝ */}
      {/* 
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", textAlign: "center" }}>
        <div style={{ width: "33%" }}>
          <b>Người ghi sổ</b>
          <div style={{ fontStyle: "italic", fontSize: "14px", marginBottom: "65px" }}>(Ký, họ tên)</div>
          <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={headerInfo.recorder} onChange={(e) => handleHeaderChange("recorder", e.target.value)} />
        </div>
        <div style={{ width: "33%" }}>
          <b>Kế toán trưởng</b>
          <div style={{ fontStyle: "italic", fontSize: "14px", marginBottom: "65px" }}>(Ký, họ tên)</div>
          <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={headerInfo.chiefAccountant} onChange={(e) => handleHeaderChange("chiefAccountant", e.target.value)} />
        </div>
        <div style={{ width: "33%" }}>
          <div style={{ fontStyle: "italic", marginBottom: 5 }}>
            Ngày <input disabled={containView} style={s.inputDottedSmall} value={headerInfo.signingDay} onChange={(e) => handleHeaderChange("signingDay", e.target.value)} /> 
            tháng <input disabled={containView} style={s.inputDottedSmall} value={headerInfo.signingMonth} onChange={(e) => handleHeaderChange("signingMonth", e.target.value)} /> 
            năm <input disabled={containView} style={{...s.inputDottedSmall, width: 50}} value={headerInfo.signingYear} onChange={(e) => handleHeaderChange("signingYear", e.target.value)} />
          </div>
          <b>Người đại diện theo pháp luật</b>
          <div style={{ fontStyle: "italic", fontSize: "14px", marginBottom: "45px" }}>(Ký, họ tên, đóng dấu)</div>
          <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={headerInfo.legalRepresentative} onChange={(e) => handleHeaderChange("legalRepresentative", e.target.value)} />
        </div>
      </div>
      */}
    </SoftBox>
  );
}

RegisterOwnSharesPurchasedInfo.propTypes = { formData: PropTypes.object };
export default RegisterOwnSharesPurchasedInfo;
